<template>
  <div class="tabbar">
    <van-tabbar v-model="active" :placeholder="true" safe-area-inset-bottom route>
      <van-tabbar-item to="/">
        <div class="tabbar_flex">
          <img src="../../static/image/jr-icon-home.png" v-if="active === 1" />
          <img src="../../static/image/jr-icon-mini.png" v-else />

          <span>{{ $t('message.user.activity') }}</span>
        </div>
      </van-tabbar-item>

      <van-tabbar-item to="/toJournalismList">
        <div class="tabbar_flex">
          <img src="../../static/image/Group.png" v-if="active === 5" />
          <img src="../../static/image/Group-1.png" v-else />
          <span>{{ $t('message.user.News') }}</span>
        </div>
      </van-tabbar-item>

      <van-tabbar-item to="/pictureAlbum">
        <div class="tabbar_flex">
          <img src="../../static/image/Group(1).png" v-if="active === 7" />
          <img src="../../static/image/Group-未选.png" v-else />
          <span>{{ $t('message.user.journal') }}</span>
        </div>
      </van-tabbar-item>

      <van-tabbar-item to="/user">
        <div class="tabbar_flex">
          <img src="../../static/image/jr-icon-mine.png" v-if="active === 3" />
          <img src="../../static/image/jr-icon-my.png" v-else />

          <span>{{ $t('message.user.my') }}</span>
          <div class="myTabbar_hint" v-show="myBadgeInfo >= 1">
            {{ this.myBadgeInfo }}
          </div>
        </div>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
//判断手机端和pc端
import device from 'current-device'
import { mapState } from 'vuex'
export default {
  name: 'Tabbar',
  data() {
    return {
      active: 0,
      isWap: true
    }
  },
  watch: {
    $route: {
      handler(n) {
        // 初始化操作
        if (this.$route.path === '/') {
          this.active = 1
        } else if (this.$route.path === '/toJournalismList') {
          this.active = 5
        } else if (this.$route.path === '/user') {
          this.active = 3
        } else if (this.$route.path == '/pictureAlbum') {
          this.active = 7
        }
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    if (this.$route.path === '/') {
      this.active = 1
    } else if (this.$route.path === '/toJournalismList') {
      this.active = 5
    } else if (this.$route.path === '/user') {
      this.active = 3
    } else if (this.$route.path == '/pictureAlbum') {
      this.active = 7
    }
    if (device.mobile()) {
      this.isWap = true
    } else if (device.ipad()) {
      this.isWap = true
    } else if (device.desktop()) {
      this.isWap = false
    }
  },
  computed: {
    ...mapState(['myBadgeInfo']) // 辅助函数 vuex中的state值
  }
}
</script>

<style scoped lang="less">
.tabbar {
  height: 56px;
  margin: 12px 0;

  .van-tabbar__placeholder {
    height: 56px !important;
  }

  /deep/.van-tabbar {
    height: 56px !important;
    background-color: #fff;
    z-index: 999;
  }

  .tabbar_flex {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    img {
      width: 24px;
      height: 24px;
    }

    span {
      margin-top: 4px;
      font-size: 12px;
      color: #a6a8ab;
    }

    .myTabbar_hint {
      position: absolute;
      top: -4px;
      right: -6px;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: #f83e3e;
      text-align: center;
      line-height: 12px;
      font-size: 11px;
      margin-left: 4px;
      color: #fff;
    }
  }

  /deep/.van-tabbar-item--active span {
    color: #3562ff !important;
  }
}
</style>
